// Dependencies
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get CompanyHierarchyModel () {
        return CompanyHierarchyModel;
    },
    get HierarchyGroupsSchema () {
        return HierarchyGroupsSchema;
    },
    get HierarchyTypeSchema () {
        return HierarchyTypeSchema;
    }
});
const _bson = require("bson");
const _zod = require("zod");
const HierarchyTypeSchema = _zod.z.enum([
    "traditional",
    "circular_leadership"
]);
const HierarchyGroupsSchema = _zod.z.object({
    traditional: _zod.z.number().int().nonnegative(),
    circular_leadership: _zod.z.number().int().nonnegative()
});
const CompanyHierarchyModel = _zod.z.object({
    _id: _zod.z.instanceof(_bson.ObjectId),
    company_id: _zod.z.instanceof(_bson.ObjectId),
    left: _zod.z.number(),
    right: _zod.z.number(),
    user_id: _zod.z.instanceof(_bson.ObjectId),
    manager_id: _zod.z.instanceof(_bson.ObjectId).nullable(),
    level: _zod.z.number(),
    hierarchy_type: HierarchyTypeSchema.optional()
});
